import React from 'react';

export const Essential: React.FC = () => {
  return <p className='text-danger ms-2'>必須</p>;
};
